import React, { Component } from 'react';
import { CardDeck, Card, Button, Row, Col } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';
import {
    formatCurrency,
    formatDate,
    formatPercentage
  } from '../../../../../utils/FormatUtil';

import './resultOptions.css';

class ResultOptions extends Component {
    constructor(){
        super();

        this.handleReturnSimulator = this.handleReturnSimulator.bind(this);
        this.handleOptionSelect = this.handleOptionSelect.bind(this);
    }

    componentDidMount() {
        const {googleAnalytics} = this.props;
        googleAnalytics({'event':'vpv-privado','sitesection':'vpv-privado','page':'/tef/dap/paso2a'});
    }

    handleReturnSimulator(){
        const {setStep, cleanResult} = this.props;
        setStep(1);
        cleanResult();

        ReactGA.event({
            category: 'Click',
            action: 'Volver a Simulador DAP'
        });
    }

    handleOptionSelect(){
        const {googleAnalytics} = this.props;
        googleAnalytics({'event':'vpv-privado','sitesection':'vpv-privado','page':'/tef/dap/paso2b'});

    }

    render() { 
        const {result, step} = this.props;

        if(step === 1){
            return <Redirect to="/simulador" />
        }

        return (
            <Card className="card-options">
                <Card.Header>
                    Selecciona una de las 3 opciones de inversión
                </Card.Header>
                <Card.Body className="body-options">
                    <CardDeck>
                        {
                            result.map((option, key) => {
                                return(
                                    <Card key={key} className={option.defecto ? 'card-option selected-border' : 'card-option'}>
                                        <Card.Body className="d-none d-sm-block">
                                            <div className={option.defecto ? 'my-card-title selected-title' : 'my-card-title'}> 
                                                Opción {key+1}
                                            </div>
                                            <div className={option.defecto ? 'card-subtitle selected-subtitle' : 'card-subtitle'}>
                                                Plazo: {`${option.plazo} días`}
                                            </div>
                                            <Row className="monto">
                                                <Col className="data-label text">
                                                    <p>Monto a invertir</p>
                                                </Col>
                                                <Col className="text">
                                                    <p><strong>{formatCurrency(option.montoInvertir)}</strong></p>   
                                                </Col>
                                            </Row>
                                            <Row className="monto">
                                                <Col className="data-label text">   
                                                    <p>Ganancia</p>
                                                </Col>
                                                <Col className="text">  
                                                    <p><strong>{formatCurrency(option.interes)}</strong></p>   
                                                </Col>
                                            </Row>
                                            <Row className="monto">
                                                <Col className="data-label text">
                                                    <p>Monto al vencimiento</p>
                                                </Col>
                                                <Col className="text">
                                                    <p><strong>{formatCurrency(option.montoRecibir)}</strong></p>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className="text text-center">
                                                    <p>Tasa base <strong>{formatPercentage(option.tasaInteres)}</strong></p>
                                                    <p>Tasa período <strong>{formatPercentage(option.tasaPeriodo)}</strong></p>
                                                </Col>
                                            </Row>
                                        
                                            <Row>
                                                <Col className="text-center">
                                                    <p><strong>Fecha de vencimiento:</strong></p>
                                                    <p>{formatDate(option.fechaVencimiento)}</p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="text-center">
                                                    <Link
                                                        onClick={this.handleOptionSelect}
                                                        to={{ pathname: '/resultado-seleccion', state: {simulationSelected: option}}}
                                                    >
                                                        Seleccionar
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        <Card.Body className="d-block d-sm-none">
                                            <Row className="header-mobile">
                                                <Col xs={8} sm={8} className="col-header">
                                                    <p>
                                                        <span className={option.defecto? 'sel-mobile-title' : '' }>Opción {key+1}</span> 
                                                        <span>{option.defecto? '' : ' - '}</span> 
                                                        <span className={option.defecto? 'sel-mobile-subtitle' : ''}>Plazo {`${option.plazo} días`}</span>
                                                    </p>
                                                </Col>
                                                <Col xs={4} sm={4} className="col-header">
                                                    <Link
                                                        onClick={this.handleOptionSelect}
                                                        to={{ pathname: '/resultado-seleccion', state: {simulationSelected: option}}}
                                                    >
                                                        Seleccionar
                                                    </Link>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="text-center">
                                                    <p><strong>Ganancia</strong></p>
                                                    <p>{formatCurrency(option.interes)}</p>
                                                </Col>
                                                <Col className="text-center tasa-border">
                                                    <p><strong>Tasa</strong></p>
                                                    <p>{formatPercentage(option.tasaInteres)}</p>
                                                </Col>
                                                <Col className="text-center">
                                                    <p><strong>Vencimiento</strong></p>
                                                    <p>{formatDate(option.fechaVencimiento)}</p>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                );
                            })
                        }
                    
                    </CardDeck>
                </Card.Body>
                <div>
                    <Button
                        onClick={this.handleReturnSimulator}
                        className="dap_btn-secondary"
                    >
                        Volver
                    </Button>
                </div>
            </Card>
            
        );
    }
}
 
export default ResultOptions;